<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="importshow"
    :maskClosable="false"
    :keyboard="false"
    @ok="handleOks"
    @cancel="handleCancel"
    ok-text="确认"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-if="this.type == 'szactivity'"
      >
        <a-form-model-item
          label="标题名称"
          label-align="left"
          style="margin-bottom: 0px"
        >
          <div class="flex">
            <a-select v-model="form.titleName" @change="choiceChange">
              <a-select-option :value="item.text" v-for="item in btlist">{{
                item.title
              }}</a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
      </a-form-model>

      <div @click="downmb" class="downmb">下载导入模板</div>
      <div>
        <a-upload
          :before-upload="beforeUpload"
          :custom-request="noopUpload"
          accept=".xls,.xlsx"
          :showUploadList="false"
        >
          <a-button style="margin-right: 20px" type="primary">导入</a-button>
        </a-upload>
        <tempalte v-if="list.length > 0">
          <a
            :href="path + item.fileUrl"
            v-for="(item, index) in list"
            :key="index"
            >{{ item.fileName }}</a
          >
        </tempalte>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  getAction,
  postAction,
  lxApplyexportTemplate,
  lxApplyexportQlTemplate,
} from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      list: [],
      importshow: false,
      type: "",
      id: "",
      path: baseURL,
      title: "",
      labelCol: { span: 3 },
      wrapperCol: { span: 12 },
      btlist: [],
      form: {
        titleName: "",
      },
      code: "szkc",
    };
  },
  methods: {
    getbtlist() {
      getAction("/baseCommon/getDictItemsByCode?code=szkcandkcsz").then(
        (res) => {
          if (res.code == 200) {
            this.btlist = res.result;
          }
        }
      );
    },
    init(type, record, title) {
      this.list = [];
      this.type = type;
      this.id = record.id;
      this.importshow = true;
      this.title = "导入" + title;
      if (this.type == "szactivity") {
        this.form.titleName = "";
        this.btlist = [];
        this.getbtlist();
      }
    },
    choiceChange() {
      if (this.form.titleName == "思政课程开展情况") {
        this.code = "szkc";
      } else if (this.form.titleName == "课程思政开展情况") {
        this.code = "kcsz";
      } else {
        this.code = "szdjy";
      }
    },
    noopUpload() {},
    handleOks() {
      this.importshow = false;
      this.list = [];
      this.$emit("rereshData");
    },
    handleCancel() {
      this.importshow = false;
    },
    downmb() {
      let params = {};
      params = {
        applyType: this.type,
      };
      if (this.type == "fundcost" || this.type == "szbaseActivity") {
        params.applyId = this.id;
      }
      if (this.type == "szactivity") {
        params.code = this.code;
      }
      if (this.type == "ideologicalPoliticalMicroCourse") {
        lxApplyexportQlTemplate({
          applyType: 3,
        }).then((res) => {
          let url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let fileName = "思政微课";
          link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url);
        });
        return;
      }
      lxApplyexportTemplate(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.type == "group") {
          console.log(this.$route.name);
          if (this.$route.name == "szStudioDataUpload") {
            fileName = "工作室团队成员";
          } else {
            fileName = "团队成员";
          }
        } else if (this.type == "szgroup") {
          fileName = "工作室团队成员";
        } else if (this.type == "achievement") {
          fileName = "成果";
        } else if (this.type == "activity") {
          fileName = "活动";
        } else if (this.type == "fund") {
          fileName = "资金来源";
        } else if (this.type == "fundcost") {
          fileName = "资金支出";
        } else if (this.type == "cooperativebase") {
          fileName = "合作基地";
        } else if (this.type == "group1") {
          fileName = "工作室团队成员";
        } else if (this.type == "barndActivity") {
          fileName = "品牌活动";
        } else if (this.type == "brandCons") {
          fileName = "品牌建设";
        } else if (this.type == "brandEffect") {
          fileName = "品牌效果";
        } else if (this.type == "honor") {
          fileName = "荣誉";
        } else if (this.type == "brandBase") {
          fileName = "品牌基地";
        } else if (this.type == "brandPropaganda") {
          fileName = "品牌宣传";
        } else if (this.type == "brandPromotion") {
          fileName = "品牌宣传";
        } else if (this.type == "szactivity") {
          if (this.code == "szkc") {
            fileName = "思政课程开展情况";
          } else if (this.code == "kcsz") {
            fileName = "课程思政开展情况";
          } else if (this.code == "szdjy") {
            fileName = "思政大教研活动开展情况";
          }
          // fileName = "思政课程与课程思政大格局";
        } else if (this.type == "team") {
          fileName = "全校团队建设";
        } else if (this.type == "cooperativebase") {
          fileName = "思政实践基地";
        } else if (this.type == "honor") {
          fileName = "荣誉";
        } else if (this.type == "culbrand") {
          fileName = "培育品牌";
        } else if (this.type == "szbaseActivity") {
          fileName = "基地实践活动";
        } else if (this.type == "annualPlan") {
          fileName = "年度计划";
        } else if (this.type == "brandAchievements") {
          fileName = "品牌成果";
        } else if (this.type == "ideologicalPoliticalEducation") {
          fileName = "思政育人";
        } else if (this.type == "ideologicalPoliticalMicroCourse") {
          fileName = "思政微课";
        } else if (this.type == "teachingresearchsituation") {
          fileName = "教研情况";
        } else if (this.type == "researchsituation") {
          fileName = "科研情况";
        } else if (this.type == "wkgroup") {
          fileName = "思政微课团队成员";
        }
        link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url);
      });
    },
    beforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      let url = "";
      if (
        this.type == "group" ||
        this.type == "szgroup" ||
        this.type == "wkgroup"
      ) {
        url = "/lxBase/teachGroupImport?applyId=";
      } else if (this.type == "achievement") {
        url = "/lxBase/achievementImport?applyId=";
      } else if (this.type == "activity") {
        url = "/lxBase/activityImport?applyId=";
      } else if (this.type == "fund") {
        url = "/lxBase/fundImport?applyId=";
      } else if (this.type == "fundcost") {
        url = "/lxBase/fundCostImport?applyId=";
      } else if (this.type == "cooperativebase") {
        url = "/lxBase/cooperativeBaseImport?applyId=";
      } else if (this.type == "brandCons") {
        url = "/lxBase/brandConsImport?applyId=";
      } else if (this.type == "honor") {
        url = "/lxBase/honorImport?applyId=";
      } else if (this.type == "brandBase") {
        url = "?applyId=";
      } else if (this.type == "brandPropaganda") {
        url = "?applyId=";
      }else if (this.type == "brandPromotion") {
        url = "/lxBase/brandPromotionImport?applyId=";
      } else if (this.type == "szactivity") {
        url = "/lxBase/szActivityImport?applyId=";
      } else if (this.type == "team") {
        url = "/lxBase/teamBuildImport?applyId=";
      } else if (this.type == "cooperativebase") {
        url = "/lxBase/cooperativeBa seImport?applyId=";
      } else if (this.type == "honor") {
        url = "/lxBase/honorImport?applyId=";
      } else if (this.type == "culbrand") {
        url = "/lxBase/culbrandImport?applyId=";
      } else if (this.type == "szbaseActivity") {
        url = "/lxBase/szbaseActivityImport?applyId=";
      } else if (this.type == "annualPlan") {
        url = "/lxBase/annualPlanImport?applyId=";
      } else if (this.type == "brandAchievements") {
        url = "/lxBase/brandAchievementsImport?applyId=";
      } else if (this.type == "ideologicalPoliticalEducation") {
        url = "/lxBase/ideologicalPoliticalEducationImport?applyId=";
      } else if (this.type == "ideologicalPoliticalMicroCourse") {
        url = "/lxBase/combinedImport?applyType=3&applyId=";
      } else if (this.type == "teachingresearchsituation") {
        url = "/lxBase/teachingresearchsituationImport?applyId=";
      } else if (this.type == "researchsituation") {
        url = "/lxBase/researchsituationImport?applyId=";
      } else if (this.type == "brandEffect") {
        url = "/lxBase/brandEffectImport?applyId=";
      }
      if (this.type == "szactivity") {
        url = url + this.id + "&code=" + this.code;
      } else {
        url = url + this.id;
      }
      postAction(url, formData).then((res) => {
        if (res.code === 200) {
          this.$message.success("导入成功");
          let that = this;
          setTimeout(function () {
            that.importshow = false;
            that.list = [];
            that.$emit("refreshData");
          }, 2000);
        } else {
          this.$message.warning(res.result.msg);
          if (res.code == "201") {
            this.list = [];
            this.list.push({
              fileName: res.result.fileName,
              fileUrl: res.result.fileUrl,
            });
            let that = this;
            that.$emit("refreshData");
          }
        }
      });
      return false;
    },
  },
};
</script>

<style scoped>
.downmb {
  line-height: 40px;
  cursor: pointer;
  color: #0f5ef1cc;
  /*margin-bottom:20px;*/
}
</style>